import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from 'src/environments/environment';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { OptionWindowUserTableModel } from 'src/app/models/tables/authentication/option-window-user-table.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';

@Injectable({
  providedIn: 'root'
})
export class OptionWindowService {

  constructor(private _httpClient: HttpClient) { }

  activateAllPermissionsByUser(userId: number): Observable<any> {
    const params = new HttpParams().set('userId', userId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.ActivateAllPermissionsByUserAsync}`,
      { params: params })
  }

  deactivateAllPermissionsByUser(userId: number): Observable<any> {
    const params = new HttpParams().set('userId', userId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.DeactivateAllPermissionsByUserAsync}`,
      { params: params })
  }

  getColumns(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.GetColumnsAsync}`);
  }

  getOptionWindowsByCompanyAuthenticated(): Observable<Array<OptionWindowModel>> {
    return this._httpClient.get<Array<OptionWindowModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.GetOptionWindowsByCompanyAuthenticated}`);
  }

  getOptionWindowsByUser(userId: number): Observable<Array<OptionWindowModel>> {
    return this._httpClient.get<Array<OptionWindowModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.GetOptionWindowsByUser}/${userId}`);
  }

  GetOptionsWindowsByUserWithPagination(userId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<OptionWindowUserTableModel>> {
    const params = new HttpParams()
      .set('userId', userId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<OptionWindowUserTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.GetOptionsWindowsByUserWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  saveOptionWindowsByUser(userId: number, optionWindowsId: number): Observable<any> {
    const params = new HttpParams().set('userId', userId).set('optionWindowId', optionWindowsId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.SaveOptionWindowsByUserAsync}`,
      { params: params })
  }

  getPermissionsForUserByWindow(window: number): Observable<Array<OptionWindowModel>> {
    return this._httpClient.get<Array<OptionWindowModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.optionWindow.GetPermissionsForUserByWindow}/${window}`);
  }

}
